import { EMAIL_REGEX, isUGPhoneNumber } from "../constants";

export default function isValidUsername(username) {
  return EMAIL_REGEX.test(username) || isUGPhoneNumber(username);
}
